import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";

import {
  FaUsers,
  FaFileAlt,
  FaUniversity,
  FaExclamationTriangle,
  FaEllipsisV
} from "react-icons/fa";
import api from "../../api";

const StatCard = ({ icon, value, label, iconBg, navigateTo }) => {
  const navigate = useNavigate();

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => navigate(navigateTo)}
      onKeyDown={(e) => e.key === 'Enter' && navigate(navigateTo)}
      className="bg-white/10 border border-white/10 backdrop-blur-lg text-blue-900 p-6 rounded-2xl flex items-start justify-between cursor-pointer hover:scale-105 hover:shadow-xl transition-all duration-300"
    >
      <div className="flex items-start gap-4">
        <div className={`p-3 rounded-xl ${iconBg} text-white shadow-md`}>
          {icon}
        </div>
        <div>
          <p className="text-3xl font-bold">{value}</p>
          <p className="text-sm text-blue-800">{label}</p>
        </div>
      </div>
      <button
        className="text-blue-400 hover:text-blue-600"
        onClick={(e) => e.stopPropagation()}
      >
        <FaEllipsisV className="h-4 w-4" />
      </button>
    </div>
  );
};

const carouselItems = [
  { id: 1, title: "Placement Drives", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/22102e12-a391-4a4b-b3bd-ccf2dbd19b8a?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100348Z&X-Amz-Expires=43200&X-Amz-Signature=716e70772f8e553e91179557e6ffffb8c82d4ddb83594b9fad2a0a41cda00384&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-03-18%20at%2020.59.26.jpeg%22" },
  { id: 2, title: "Internship Drive", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/277f5c77-5152-4647-aae7-f720cf5683f9?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100452Z&X-Amz-Expires=43200&X-Amz-Signature=f47375d16ccc1aabb8eade447677a578fa2c2b92cc6e62c5350ca84e8233a6d6&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-07-13%20at%2015.12.26.jpeg%22" },
  { id: 3, title: "Hackathon Winners", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/e6d9e54f-c2f0-4598-a0b8-5b1572182576?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100710Z&X-Amz-Expires=43200&X-Amz-Signature=644a2c814173b528cd7ec9d9b37cad2e6dbf1a9571582dfab224995a6cfa4073&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-07-13%20at%2015.19.49.jpeg%22" },
  { id: 4, title: "Tech Fest Highlights", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/e842b1b6-f1b6-40bf-9652-2c1d69106c52?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100542Z&X-Amz-Expires=43200&X-Amz-Signature=7c81a3e8667d35f89c6e644d5c1ce6cb1f3d0d02d9b19f56957ab25da14d9354&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-07-13%20at%2015.15.18.jpeg%22" },
  { id: 5, title: "Hackathon Winners", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/e8ce80f6-6563-4466-b922-63447be35723?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100601Z&X-Amz-Expires=43200&X-Amz-Signature=db107e10209a9f4da95e85952498da9ef7e90d3df651d5c24cc099f25e7c66ba&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-07-13%20at%2015.19.48%20%281%29.jpeg%22" },
  { id: 6, title: "CNC web world", img: "https://upnow-prod.ff45e40d1a1c8f7e7de4e976d0c9e555.r2.cloudflarestorage.com/jJCcwi7yuXdqB8P5zb8Nlb4aFZy2/a42b11ca-8c30-412f-9bfe-0dbd9122dbac?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cdd12e35bbd220303957dc5603a4cc8e%2F20250713%2Fauto%2Fs3%2Faws4_request&X-Amz-Date=20250713T100638Z&X-Amz-Expires=43200&X-Amz-Signature=95bae82d91de79d2fbbe3baa02afde9dbcf36ca1505ddeaaaa66de0ee73a7f52&X-Amz-SignedHeaders=host&response-content-disposition=attachment%3B%20filename%3D%22WhatsApp%20Image%202025-07-13%20at%2015.19.48.jpeg%22" },

];

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  arrows: false,
};


export default function AdminHomePage() {
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalReports: 0,
    totalColleges: 0,
    pendingRequests: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/admin/pending-counts');
        const data = response.data;

        setStats({
          totalStudents: data.studentCount,
          totalReports: data.reportCount,
          totalColleges: data.collegeCount,
          pendingRequests: data.collegeCount, // Adjust if needed
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="p-6 text-white text-center">
        Loading dashboard data...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-400 via-white to-green-400 text-white p-6 md:p-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard
          icon={<FaUsers className="h-6 w-6" />}
          value={stats.totalStudents}
          label="Total Students"
          iconBg="bg-gradient-to-br from-orange-500 to-yellow-400"
          navigateTo="/admin/registered-students"
        />

        <StatCard
          icon={<FaFileAlt className="h-6 w-6" />}
          value={stats.totalReports}
          label="Total Reports"
          iconBg="bg-gradient-to-br from-blue-500 to-sky-400"
          navigateTo="/admin/reports"
        />

        <StatCard
          icon={<FaUniversity className="h-6 w-6" />}
          value={stats.totalColleges}
          label="Total Colleges"
          iconBg="bg-gradient-to-br from-green-500 to-lime-400"
          navigateTo="/admin/registered-collages"
        />

        <StatCard
          icon={<FaExclamationTriangle className="h-6 w-6" />}
          value={stats.pendingRequests}
          label="Pending Requests"
          iconBg="bg-gradient-to-br from-yellow-300 to-orange-400"
          navigateTo="/admin/pending-requests"
        />
      </div>
      <div className="mt-10">
  <h2 className="text-2xl font-bold text-blue-900 mb-4">What's New</h2>
  <Slider {...carouselSettings}>
    {carouselItems.map((item) => (
      <div key={item.id} className="px-4">
        <div className="rounded-2xl overflow-hidden shadow-lg">
          <img
            src={item.img}
            alt={item.title}
            className="w-full h-85 object-cover"
          />
          <div className="bg-white text-blue-900 text-center py-2 font-semibold">
            {item.title}
          </div>
        </div>
      </div>
    ))}
  </Slider>
</div>

    </div>
  );
}